import { Form, Select } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { Link, useParams } from "react-router-dom";
import { useFetchStandingsConfigurations } from "../../../entities/api";

export const StandingsConfigurationSelect = ({ defaultValue, name }) => {
  const { formatMessage } = useIntl();
  const { customerId, sport, organizationId } = useParams();
  const [value, setValue] = useState(defaultValue);
  const { data: standingConfigList, isLoading: fetchStandingConfigurationsLoading } = useFetchStandingsConfigurations({
    limit: 1000,
  });

  const handleChangeValue = (val) => {
    setValue(val);
  };

  return (
    <>
      <Form.Item name={name} style={{ width: "100%" }}>
        <Select
          showSearch
          value={value}
          disabled={fetchStandingConfigurationsLoading}
          defaultValue={defaultValue}
          loading={fetchStandingConfigurationsLoading}
          onChange={handleChangeValue}
          filterOption={(input, option) => (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())}
        >
          <Select.Option value={""}>--</Select.Option>
          {standingConfigList?.map((config) => (
            <Select.Option
              label={config?.nameLocal}
              value={config?.standingConfigurationId}
              key={config?.standingConfigurationId}
            >
              {config?.nameLocal}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      {value && (
        <div>
          <Link
            to={`/${customerId}/admin/${sport}/${organizationId}/standings-configuration/manage/${value}`}
          >
            {formatMessage({
              id: "view.configuration",
              defaultMessage: "View Configuration",
            })}
          </Link>
        </div>
      )}
    </>
  );
};
